import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TutorAcademyService } from '../../../services/tutor-academy.service';

@Component({
  selector: 'app-tutor-academy-welcome-dialog',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './tutor-academy-welcome-dialog.component.html',
  styleUrl: './tutor-academy-welcome-dialog.component.scss'
})
export class TutorAcademyWelcomeDialogComponent {

  @Output() onClose = new EventEmitter<void>();

  constructor(
    private tutorAcademyService: TutorAcademyService,
    private translateService: TranslateService,
    private router: Router,
  ) { }

  openRulesCourse(): void {
    const course = this.tutorAcademyService.getMandatoryCourse();
    if (!course) {
      return;
    }
    this.tutorAcademyService.startCourse(course.slug);
    this.openAcademyRoute(course.slug);
  }

  openAcademyOverview(): void {
    this.openAcademyRoute();
  }

  close(): void {
    this.onClose.emit();
  }

  private openAcademyRoute(slug?: string): void {
    this.translateService.get('ROUTES.Misc_tutor_academy').subscribe(route => {
      this.close();
      this.router.navigate(slug ? [route, slug] : [route]);
    });
  }
}
